var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 10.7998L26.6667 12.6331L23.3334 15.7998V26.6665H28C29.1047 26.6665 30 25.7711 30 24.6665V10.7998Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.7998L4.40933 11.9398L8.66667 15.7998V26.6665H4C2.89533 26.6665 2 25.7711 2 24.6665V10.7998Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 7.4668L16 12.9668L8.66667 7.4668L8 11.3335L8.66667 15.8001L16 21.3001L23.3333 15.8001L24 11.3335L23.3333 7.4668Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.19883V10.8002L8.66667 15.8002V7.46683L6.584 5.90616C6.088 5.53416 5.48533 5.3335 4.86533 5.3335C3.28267 5.3335 2 6.61616 2 8.19883Z",
    fill: "#C62828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8.19883V10.8002L23.3334 15.8002V7.46683L25.416 5.90616C25.912 5.53416 26.5147 5.3335 27.1347 5.3335C28.7174 5.3335 30 6.61616 30 8.19883Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.ed26f8fc678a38c711319bdab3ff0be7.svg";
export { ForwardRef as ReactComponent };